import "./NavBar.css";
import Navbar from "react-bootstrap/Navbar";

import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { useSelector } from "react-redux";

import logo from "./logo.svg";

function NavBar() {
  const user = useSelector((state) => state.user);
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const totalQuantity = shoppingCart
    .map((item) => item.quantity)
    .reduce((prev, curr) => prev + curr, 0);

  return (
    <Navbar
      className="menu bg-opacity-75 fixed-top shadow-sm"
      bg="white"
      expand="lg"
    >
      <Container className="nav p-0 mt-2 mb-2">
        <Navbar.Brand className="d-flex align-items-start">
          <Link to="/">
            <img className="titulo ps-3" src={logo} alt="" />
            {/* <img className="titulo" src="./hackoffe.png" alt="" /> */}
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse>
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="d-flex justify-content-between"
          >
            <Nav className="fw-bold">
              <Nav.Link as={"div"}>
                <Link to="/" className="text-decoration-none text-dark">
                  HOME
                </Link>
              </Nav.Link>
              <Nav.Link as={"div"}>
                <Link
                  to="/category/1"
                  className="text-decoration-none text-dark"
                >
                  COFFEE
                </Link>
              </Nav.Link>
              <Nav.Link as={"div"}>
                <Link
                  to="/category/2"
                  className="text-decoration-none text-dark"
                >
                  TEA
                </Link>
              </Nav.Link>
              <Nav.Link as={"div"}>
                <Link
                  to="/category/3"
                  className="text-decoration-none text-dark"
                >
                  SWEETS
                </Link>
              </Nav.Link>
            </Nav>
            <Nav className="d-flex align-items-end">
              <Nav.Link as={"div"}>
                {user.firstName && (
                  <span className="me-3 fw-bold">Hello {user.firstName}!</span>
                )}

                <Link
                  to={user.id ? "/profile" : "/login-register"}
                  className="text-decoration-none "
                >
                  <i className="fa-solid fa-user fa-xl text-dark"></i>
                </Link>
              </Nav.Link>
              <Nav.Link as={"div"}>
                <Link
                  to="/ShoppingCart"
                  className="fa-layers fa-fw position-relative"
                >
                  <i className="fa-solid fa-cart-shopping fa-xl position-relative text-dark"></i>
                  {shoppingCart.length > 0 ? (
                    <span className="counterCart text-white fw-bold bg-color-green badge rounded-circle">
                      {totalQuantity}
                    </span>
                  ) : (
                    ""
                  )}
                </Link>
              </Nav.Link>

              <Nav.Link
                as={"a"}
                href="https://hackoffee-admin.vercel.app"
                target="_blank"
                className="text-end text-dark fw-bold"
              >
                Admin
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
